.tableContainer {
  width: 100%;
  border-radius: 12px;
  background-color: var(--bc-color-bg-container);
  position: relative;
  z-index: 1;

  .tableBar {
    padding: 24px 24px 16px;

    > div {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .addButton {
      display: flex;
      justify-content: flex-end;

      .button {
        padding: 0 9px;

        .icon {
          font-size: 20px;
        }
      }
    }
  }

  .tableBarEmpty {
    padding: 0;
  }

  .total {
    color: var(--bc-color-text-secondary);
    font-size: 12px;
  }

  .pagination {
    padding: 0 16px;
    text-align: right;
  }

  tr > th.parentCell, tr > td.parentCell, tr > th.cell, tr > td.cell {
    padding: 14px 8px 5px;
  }

  tr > th.parentCell {
    text-align: center;
  }

  .settingButton {
    position: absolute;
    top: 15px;
    right: 20px;
    // calc(var(--columns-count, 0) * 2 + 2 + 1) is set on sticky table header
    z-index: calc(var(--columns-count, 0) * 2 + 4);

    button {
      font-size: 18px;
      line-height: 1;
    }
  }

  :global {
    .ant-table-title {
      position: relative;
      padding: 0;
    }

    .ant-table-wrapper .ant-table-thead >tr:not(:last-child)>td {
      border-bottom: 0;
    }

    .ant-table-wrapper .ant-table {
      font-family: 'Roboto', serif;
    }

    .ant-table-wrapper .ant-table-thead >tr {
      >td, >th {
        font-size: 12px;
        font-weight: 400;
        background: var(--bc-color-bg-container);
        border-color: var(--bc-table-header-split-color);
        overflow-wrap: initial;

        &::before {
          display: none;
        }

        &:first-child {
          padding-left: 25px;
        }

        &.ant-table-selection-column {
          padding: 8px;
        }
      }
    }

    .ant-table-tbody > tr > td {
      border: none;
    }

    .ant-table-content {
      width: 100%;
      overflow: auto;

      table {
        border-collapse: collapse !important;

        thead {
          border: none;

          th, td {
            font-size: 12px;
            font-weight: 400;
            background: var(--bc-color-bg-container);
            overflow-wrap: initial;

            &::before {
              display: none;
            }

            &:first-child {
              padding-left: 25px;
            }
          }
        }
      }

      tr > th.group {
        padding: 0 15px 10px;
      }
    }

    .ant-table-expanded-row-level-1 > td {
      padding: 0;
      &:first-child {
        padding: 0;
      }
    }

    .ant-table-tbody > tr.ant-table-row:hover > td {
      background-color: var(--bc-table-row-hover-bg);
    }

    .ant-table-tbody > tr.ant-table-row {
      &:not(:last-child) {
        td {
          border-bottom-width: 0;
        }
      }
    }

    .ant-table-column-sorters {
      padding: 0;
      justify-content: unset;

      .ant-table-column-title {
        flex: unset;
      }

      & > span:first-child {
        margin-right: 10px;
      }

      &:after {
        display: none;
      }
    }

    .ant-table-cell-with-append {
      display: flex;
      height: auto;
    }
  }

  .expandedRow {
    td {
      font-weight: 700;
    }
  }

  table {
    border-collapse: collapse !important;

    thead {
      border: none;

      th {
        font-size: 12px;
        font-weight: 400;
        background: var(--bc-color-bg-container);
        overflow-wrap: initial;

        &::before {
          display: none;
        }

        &:first-child {
          padding-left: 25px;
        }
      }
    }
  }

  tr > th.group {
    padding: 0 8px 10px;
  }
}

.bordered {
  :global {
    .ant-table-content thead.ant-table-thead, thead.ant-table-thead {
      border-top: 1px solid var(--bc-table-header-split-color);
      border-bottom: 1px solid var(--bc-table-header-split-color);
    }
  }

  &.withoutTabBar {
    table > thead {
      border-top: none;
    }
  }
  tr > th.parentCell, tr > th.cell, tr > td.cell {
    border-right: 1px solid var(--bc-table-header-split-color);
    border-left: 1px solid var(--bc-table-header-split-color);
    &:first-child {
      border-left: none;
    }

    &:last-child {
      border-right: none;
    }

    &:nth-child(2) {
      border-left: none;
    }
  }
  .group {
    border: none;

    &.borderRight {
      border-right: 1px solid var(--bc-table-header-split-color);

      &:last-child {
        border-right: none;
      }
    }

    &.borderLeft {
      border-left: 1px solid var(--bc-table-header-split-color);

      &:first-child {
        border-left: none;
      }
    }
  }
  tr:last-child, tr:last-child {
    td {
      border-bottom: 1px solid var(--bc-table-header-split-color);
    }
  }
}



tr > td.cell, tr > th.cell {
  text-align: left;
}
